import React from 'react' ;

import DropdownFamilyTypes from "./UI/Extensions/DropdownFamilyTypes";
import DropdownContactApproved from "./UI/Extensions/DropdownContactApproved";
import DropdownRelationshipSelect from "./UI/Extensions/DropdownRelationshipSelect";
import DropdownSiblingSelect from "./UI/Extensions/DropdownSiblingSelect";
import DropdownUserContractTypes from "./UI/Extensions/DropdownUserContractTypes";
import DropdownChildStatus from "./UI/Extensions/DropdownChildStatus";
import DropdownDocumentTypes from "root/Forms/UI/Extensions/DropdownDocumentTypes";
import DropdownResourceTypes from "root/Forms/UI/Extensions/DropdownResourceTypes";
import DropdownTeams from "root/Forms/UI/Extensions/DropdownTeams";
import DropdownUserTypes from "root/Forms/UI/Extensions/DropdownUserTypes";
import DropdownLetterboxDecisions from "root/Forms/UI/Extensions/DropdownLetterBoxDecisions";

const renderDropdownUserTypes = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownUserTypes onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                             id={definition.ref}
                             name={definition.ref}
                             label={definition.label}
                             errorText={definition.errorText}
                             defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                             value={fieldHandlers.getFieldValue(definition.ref)}
                             readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                             isValid={fieldHandlers.isFieldValid(definition.ref)}
                             key={definition.ref}
                             tabIndex={definition.tabIndex}
                             renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownFamilyTypes = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownFamilyTypes onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                             id={definition.ref}
                             name={definition.ref}
                             label={definition.label}
                             errorText={definition.errorText}
                             defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                             value={fieldHandlers.getFieldValue(definition.ref)}
                             readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                             isValid={fieldHandlers.isFieldValid(definition.ref)}
                             key={definition.ref}
                             tabIndex={definition.tabIndex}
                             renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownResourceTypes = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownResourceTypes onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                             id={definition.ref}
                             name={definition.ref}
                             label={definition.label}
                             errorText={definition.errorText}
                             defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                             value={fieldHandlers.getFieldValue(definition.ref)}
                             readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                             isValid={fieldHandlers.isFieldValid(definition.ref)}
                             key={definition.ref}
                             tabIndex={definition.tabIndex}
                             renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownContactApproved = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownContactApproved onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                                 id={definition.ref}
                                 name={definition.ref}
                                 label={definition.label}
                                 errorText={definition.errorText}
                                 defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                                 value={fieldHandlers.getFieldValue(definition.ref)}
                                 readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                                 isValid={fieldHandlers.isFieldValid(definition.ref)}
                                 key={definition.ref}
                                 tabIndex={definition.tabIndex}
                                 renderErrorDiv={fieldHandlers.shouldDisplayErrors()  && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownRelationshipSelect = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownRelationshipSelect onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                                    id={definition.ref}
                                    name={definition.ref}
                                    label={definition.label}
                                    errorText={definition.errorText}
                                    defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                                    value={fieldHandlers.getFieldValue(definition.ref)}
                                    readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                                    isValid={fieldHandlers.isFieldValid(definition.ref)}
                                    key={definition.ref}
                                    tabIndex={definition.tabIndex}
                                    renderErrorDiv={fieldHandlers.shouldDisplayErrors()  && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownChildStatus = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownChildStatus onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                                    id={definition.ref}
                                    name={definition.ref}
                                    label={definition.label}
                                    errorText={definition.errorText}
                                    defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                                    value={fieldHandlers.getFieldValue(definition.ref)}
                                    readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                                    isValid={fieldHandlers.isFieldValid(definition.ref)}
                                    key={definition.ref}
                                    tabIndex={definition.tabIndex}
                                    renderErrorDiv={fieldHandlers.shouldDisplayErrors()  && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownSiblingSelect = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownSiblingSelect onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                               id={definition.ref}
                               name={definition.ref}
                               label={definition.label}
                               errorText={definition.errorText}
                               defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                               value={fieldHandlers.getFieldValue(definition.ref)}
                               readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                               isValid={fieldHandlers.isFieldValid(definition.ref)}
                               key={definition.ref}
                               tabIndex={definition.tabIndex}
                               renderErrorDiv={fieldHandlers.shouldDisplayErrors()  && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownUserContractTypes = (props, definition, fieldHandlers) =>
{
    return (
        <DropdownUserContractTypes onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                                   id={definition.ref}
                                   name={definition.ref}
                                   label={definition.label}
                                   errorText={definition.errorText}
                                   defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                                   value={fieldHandlers.getFieldValue(definition.ref)}
                                   readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                                   isValid={fieldHandlers.isFieldValid(definition.ref)}
                                   key={definition.ref}
                                   tabIndex={definition.tabIndex}
                                   renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownDocumentTypes = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownDocumentTypes onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                               id={definition.ref}
                               name={definition.ref}
                               label={definition.label}
                               errorText={definition.errorText}
                               defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                               value={fieldHandlers.getFieldValue(definition.ref)}
                               readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                               isValid={fieldHandlers.isFieldValid(definition.ref)}
                               key={definition.ref}
                               tabIndex={definition.tabIndex}
                               renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownTeams = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownTeams onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                               id={definition.ref}
                               name={definition.ref}
                               label={definition.label}
                               errorText={definition.errorText}
                               defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                               value={fieldHandlers.getFieldValue(definition.ref)}
                               readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                               isValid={fieldHandlers.isFieldValid(definition.ref)}
                               key={definition.ref}
                               tabIndex={definition.tabIndex}
                               renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderDropdownLetterboxDecisions = (props, definition, fieldHandlers ) =>
{
    return (
        <DropdownLetterboxDecisions onChange={fieldHandlers.getChangeHandlerForType('dropdown')}
                       id={definition.ref}
                       name={definition.ref}
                       label={definition.label}
                       errorText={definition.errorText}
                       defaultValue={fieldHandlers.getFieldValue(definition.ref)}
                       value={fieldHandlers.getFieldValue(definition.ref)}
                       readOnly={props.readonly === true || props.mode === 'view' ? 'readonly' : ''}
                       isValid={fieldHandlers.isFieldValid(definition.ref)}
                       key={definition.ref}
                       tabIndex={definition.tabIndex}
                       renderErrorDiv={fieldHandlers.shouldDisplayErrors() && !fieldHandlers.isFieldValid(definition.ref)}/>
    )
}

const renderHeader6 = (props, definition, fieldHandlers) =>
{
    return (
        <h6>{definition.label}</h6>
    )
}

const renderBoilerplate = ( props, definition, fieldHandlers ) =>
{
    return (
        <div className="boilerplate">{definition.label}</div>
    )
}
const renderBoilerplate2 = ( props, definition, fieldHandlers ) =>
{
    return (
        <div className="boilerplate2">{definition.label}</div>
    )
}

const renderExtensions = ( props, definition, fieldHandlers ) =>
{
    switch (definition.field_type)
    {
        case 'header6':
            return renderHeader6(props, definition, fieldHandlers) ;
        case 'boilerplate':
            return renderBoilerplate(props, definition, fieldHandlers) ;
        case 'boilerplate2':
            return renderBoilerplate2(props, definition, fieldHandlers) ;
        case 'dropdown_familytype':
            return renderDropdownFamilyTypes(props, definition, fieldHandlers);
        case 'dropdown_resourcetype':
            return renderDropdownResourceTypes(props, definition, fieldHandlers);
        case 'dropdown_contact_approved':
            return renderDropdownContactApproved(props, definition, fieldHandlers);
        case 'dropdown_relationship_select':
            return renderDropdownRelationshipSelect(props, definition, fieldHandlers);
        case 'dropdown_child_status':
            return renderDropdownChildStatus(props, definition, fieldHandlers);
        case 'dropdown_sibling_select':
            return renderDropdownSiblingSelect(props, definition, fieldHandlers);
        case 'dropdown_user_contract_type':
            return renderDropdownUserContractTypes(props, definition, fieldHandlers);
        case 'dropdown_letterbox_item_type':
            return renderDropdownDocumentTypes(props, definition, fieldHandlers);
        case 'dropdown_teams':
            return renderDropdownTeams(props, definition, fieldHandlers);
        case 'dropdown_userType':
            return renderDropdownUserTypes(props, definition, fieldHandlers);
        case 'dropdown_letterbox_decisions':
            return renderDropdownLetterboxDecisions(props, definition, fieldHandlers);

        default:
            throw (new Error('Invalid Field Type: ' + definition.field_type));
    }
}

const validateExtension = ( definition, value ) =>
{
    let isValid = true ;

    switch (definition.field_type)
    {
        case 'input':
            if ( definition.validation !== undefined )
            {
                if ( definition.validation.required === true )
                {
                    if (value.length === 0)
                    {
                        isValid = false;
                    }
                }
            }
            break ;
    }

    return isValid ;
}


export { renderExtensions, validateExtension } ;
